import { FC } from "react";
import { NavLink } from "react-router-dom";
import classNames from "classnames";

import styles from "./Nav.module.scss";

import { NavLinkType } from "@/root/types";

interface NavProps {
  navLinks: NavLinkType[];
}

const Nav: FC<NavProps> = ({ navLinks }) => {
  return (
    <nav className={styles.nav}>
      <ul>
        {navLinks.map((link) => (
          <li key={link.title}>
            <NavLink
              className={({ isActive }) =>
                classNames(styles.navLink, { [styles.navLinkActive]: isActive })
              }
              to={link.path}
            >
              {link.title}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
